import { getCLS, getFID, getLCP, getFCP, getTTFB, type Metric } from 'web-vitals';
import { trackEvent } from './analytics';

// Send a subset of web vitals with light payloads.
// Sampling: send 1 in N (default 1/1 in dev, 1/10 in prod)
const SAMPLE_RATE = parseInt(process.env.REACT_APP_WEB_VITALS_SAMPLE_RATE || (process.env.NODE_ENV === 'production' ? '10' : '1'), 10);

function shouldSample() {
  if (SAMPLE_RATE <= 1) return true;
  return Math.floor(Math.random() * SAMPLE_RATE) === 0;
}

function sendMetric(name: string, metric: Metric) {
  if (!shouldSample()) return;
  trackEvent('web_vital', {
    metric: name,
    value: Math.round(metric.value),
    rating: (metric as any).rating,
    id: metric.id,
  });
}

export function startWebVitals() {
  try {
    // web-vitals v2 uses get* APIs and does not include INP
    getCLS((m: Metric) => sendMetric('CLS', m));
    getFID((m: Metric) => sendMetric('FID', m));
    getLCP((m: Metric) => sendMetric('LCP', m));
    getFCP((m: Metric) => sendMetric('FCP', m));
    getTTFB((m: Metric) => sendMetric('TTFB', m));
  } catch {
    // ignore if not supported
  }
}
